import { createRouter, createWebHashHistory } from 'vue-router';
import { solverRoutes } from '@/modules/solvers';
import { geoMonitorRoutes } from '@/modules/geo-monitor';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import('./pages/MainPage.vue'),
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('./debug/TestPage.vue'),
    },
    {
      path: '/bench',
      name: 'bench',
      component: () => import('./debug/LatencyBenchmarkPage.vue'),
    },
    {
      path: '/multi-sim',
      name: 'multi-sim',
      component: () => import('./pages/MultiSimPage.vue'),
    },
    {
      path: '/monitor',
      name: 'monitor',
      component: () => import('./pages/AlgorithmMonitorPage.vue'),
    },
    {
      path: '/radar/debug/:id',
      name: 'radar-debug',
      component: () => import('./pages/RadarDebugPage.vue'),
    },
    ...geoMonitorRoutes,
    ...solverRoutes,
  ],
});

export default router;
